if($('.video-preview').length) {
    $('.video-preview')[0].play();
}
